import React from 'react'
import { Grid } from '@material-ui/core'
import { Checkbox } from '@progress/kendo-react-inputs'
import { useTranslation } from "react-i18next"
import { Field } from '@progress/kendo-react-form'



/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description Layout of the Contract Bullet Action component
 */
const ContractBulletActionPure = (props) => {
  const { t } = useTranslation()

  return (
    <fieldset className={'k-form-fieldset fieldset'}>
      <Grid container spacing={4} style={{ marginBottom: '20px' }}>
        <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='contract-bullet-action'>
          <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
            <Field
              style={{ maxWidth: '15px', marginLeft: '30px' }}
              id={'termsAndConditions'}
              label={t('contractBulletActionPure.termsCondition')}
              component={Checkbox}
              value={props.termnsAndConditions}
              onChange={props.onAcceptTermnsAndConditions}
            />
          </Grid>
        </Grid>
        {(props.userTypeId === Number(process.env.REACT_APP_USER_TYPE_COLABORADOR) || props.userTypeId === Number(process.env.REACT_APP_USER_TYPE_INVITADO)) ?
          null
          :
          <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='contract-bullet-action'>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
              <Field
                style={{ maxWidth: '15px', marginLeft: '30px' }}
                id={'acceptPlan'}
                label={t('contractBulletActionPure.acceptPlan')}
                component={Checkbox}
                value={props.planChecked}
                onChange={props.onAcceptPlan}
              />
            </Grid>
          </Grid>
        }
      </Grid>
    </fieldset>
  )
}

export { ContractBulletActionPure as default }
